import { gql } from '@apollo/client';

export default gql`
  query ReportMarketPreferencesQuery(
    $reportID: UUID!
    $productID: Int
  ) {
    allRpMarketPreferences(
      condition: {
        reportId: $reportID
        productId: $productID
      }
    ) {
      nodes {
        product: productByProductId {
          id
          name
        }
        version
        pqRating
        percentPop
      }
    }
  }
`;
